export default "__VITE_ASSET__D1sYq8aN__"